import { SET_BOARDS_DATA } from '../constants';

export default function boardsReducer(state, action) {
  const defaultState = {
    boards: {},
    sum: {},
    sumRegular: {},
  };
  if (!state) {
    state = defaultState;
  }
  switch (action.type) {
    case SET_BOARDS_DATA:
      const sum = {};
      const sumRegular = {};
      let zone;
      Object.keys(action.data)?.forEach((zone_id) => {
        zone = action.data[zone_id];
        // const max1 = Math.max(0, zone.maximum - zone.current);
        if (!sum[zone.name]) {
          sum[zone.name] = {};
        }
        if (!sumRegular[zone.name]) {
          sumRegular[zone.name] = {};
        }
        sum[zone.name].free = zone.free_onetime; // Math.max(0, max1 - zone.regular);
        sum[zone.name].limit = zone.onetime; // max1;
        sum[zone.name].maximum = 0;

        sumRegular[zone.name].free = zone.free_regular; // Math.max(0, max1 - zone.regular);
        sumRegular[zone.name].limit = zone.regular; // max1;
        sumRegular[zone.name].maximum = 0;
      });

      return {
        ...state,
        boards: {
          ...state.boards,
          ...action.data,
        },
        sum,
        sumRegular,
      };
    default:
      return state;
  }
}
